import React, { useEffect, useState, useCallback } from 'react';

import Spinner from 'react-bootstrap/Spinner';
import useLocalStorage from 'hooks/useLocalStorage';

import LoggedUserContext from './context';

import * as api from 'api/auth';

const LoggedUserProvider = ({ children }) => {
  const [isAutenticating, setIsAuthenticating] = useState(true);
  const [loggedUser, setUser] = useLocalStorage('loggedUser', null);

  const saveUser = useCallback(
    (user, profile) => {
      setUser({ ...user, profile });
    },
    [setUser]
  );

  const login = useCallback(
    async googleResponse => {
      const user = await api.convertToken(googleResponse.accessToken);
      saveUser(user, googleResponse.profileObj);
    },
    [saveUser]
  );

  const logout = useCallback(async () => {
    try {
      await api.revokeToken(loggedUser.access_token);
      setUser(null);
    } catch (err) {
      setUser(null);
    }
  }, [loggedUser, setUser]);

  useEffect(() => {
    async function getCurrentUser() {
      try {
        setIsAuthenticating(true);
        await api.setAuthHeaders(loggedUser.token_type, loggedUser.access_token);
        await api.fetchMe();
        setIsAuthenticating(false);
      } catch (error) {
        if ([401].includes((error.response || {}).status)) {
          logout();
        }
      }
    }

    if (!loggedUser) {
      setIsAuthenticating(false);
      return;
    }

    getCurrentUser();
  }, [loggedUser, logout]);

  return (
    <LoggedUserContext.Provider value={{ loggedUser, login, logout }}>
      {!isAutenticating ? (
        children
      ) : (
        <div className="text-center">
          <Spinner animation="grow" size="xl" />
        </div>
      )}
    </LoggedUserContext.Provider>
  );
};

export default LoggedUserProvider;
